export default {"previous":"&laquo; Previous","next":"Next &raquo;"}